<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.especialista.labels.titulo")',
        :voltarPara='{ route: "Especialistas" }'
    )
    .detalhes-especialista
        h3.detalhes-especialista__titulo {{ $t('mensagens.especialista.labels.dadosCadastrais') }}
        .detalhes-especialista__card
            Resume(resumeId='detalhes-especialista', :resume='resumeList')
        .detalhes-especialista__card
            ResumeList(
                resumeId='detalhes-especialista-regionais',
                :label='$t("mensagens.especialista.labels.regionais")',
                :resume='regionaisVinculadas'
            )
        .footer
            .footer__btn.voltar(@click='irParaEspecialistas')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
</template>
<script>
import services from '@/views/contratos-originacao/especialista/services';
import contratoOriginacaoService from '@/services/ContratoOriginacaoService';
import EventBus from '@/utils/eventBus';

export default {
    name: 'DetalhesEspecialista',
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        Resume: () =>
            import('@/components/contratosOriginacao/formulario/Resume'),
        ResumeList: () =>
            import('@/components/contratosOriginacao/formulario/ResumeList')
    },
    data() {
        return {
            dados: {},
            regionaisVinculadas: [],
            regionais: [],
            especialista: {}
        };
    },
    computed: {
        resumeList() {
            const keysValids = ['idBunge', 'nome'];
            const keyMap = keysValids.map(key => ({
                key,
                label: this.$t(`mensagens.especialista.keys.${key}`),
                value: this.dados[key] || '--'
            }));

            return keyMap.sort(
                (a, b) => keysValids.indexOf(a.key) - keysValids.indexOf(b.key)
            );
        }
    },
    mounted() {
        this.carregar();
    },
    methods: {
        async carregar() {
            this.loadingScreen(true);
            await Promise.all([
                this.buscarRegionais(),
                this.buscarEspecialista()
            ]);
            this.montarDados();
            this.loadingScreen(false);
        },
        async buscarEspecialista() {
            const { id } = this.$route.params;
            if (!id) return;
            try {
                const { data } = await services.buscarEspecialistaPorId(id);
                this.especialista = data;
            } catch (error) {
                this.$notify.error({
                    message: error?.message || error
                });
            }
        },
        montarDados() {
            this.dados = {
                nome: this.especialista.nome,
                idBunge: this.especialista.idBunge
            };

            if (this.especialista?.idsRegionais) {
                const regionaisFiltradas = this.regionais.filter(regional =>
                    this.especialista.idsRegionais.includes(regional.id)
                );
                this.regionaisVinculadas = regionaisFiltradas.map(regional => ({
                    id: regional.id,
                    value: regional.nome
                }));
            }
        },
        buscarRegionais() {
            return contratoOriginacaoService
                .buscarRegionais()
                .then(({ data }) => {
                    if (data.length > 0) {
                        this.regionais = data;
                    }
                });
        },
        irParaEspecialistas() {
            this.$router.push({ name: 'Especialistas' });
        },
        loadingScreen(isLoading) {
            const options = {
                mostrarLoading: isLoading,
                lockMessage: this.$t('mensagens.sistema.carregando')
            };
            EventBus.$emit('emit-componente-carregando', options);
        }
    }
};
</script>

<style lang="scss" scoped>
.detalhes-especialista {
    margin: 20px;
    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }
    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();
        & + & {
            margin-top: 20px;
        }
    }
}

.footer {
    display: flex;
    justify-content: flex-end !important;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}
.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
